/**
 * @module containers/confirmation-page
 * @description Barrel export for ConfirmationPage container
 */

export { ConfirmationPage } from './confirmation-page';
